export enum SEND_EMAIL_CODE_PURPOSE {
  REGISTER = 'REGISTER',
  RESET_PASSWORD = 'RESET_PASSWORD'
}

/** 邮箱验证码错误时服务端在 403 响应体 message 中返回的标识 */
export const ERROR_REGISTER_CODE = 'ERROR_REGISTER_CODE';

export enum EEnterpriseRole {
  Admin = 'ADMIN',
  User = 'USER'
}

export interface IUserAppointment {
  /** 部门 ID */
  departmentBizId: string;
  /** 部门名 */
  departmentName: string;
  /** 职位 */
  position: string;
}

interface IUserEnterprise {
  enterpriseId: string;
  enterpriseName: string;
  memberId: string;
  memberRole: EEnterpriseRole;
  /** 部门与职位 */
  appointments: IUserAppointment[];
}

/** 用户信息 */
export interface IUserProfile {
  /** 用户头像 */
  avatar: string | null;
  /** 邮箱 */
  email: string;
  /** 是否为系统管理后台管理员 */
  isPortalAdmin: number;
  /** 最后修改密码时间 */
  lastChangePwdTime: string | null;
  /** 最后在线时间 */
  lastOnlineTime: string | null;
  /** 名称 */
  name: string;
  /** 电话 */
  phone: string | null;
  /** 注册来源 */
  registerSource: number | null;
  /** 用户冻结时间 */
  userFrozeTime: string | null;
  /** 用户唯一id */
  userId: string;
  /** 用户状态 */
  userStatus: number;
  /** 企业信息 */
  enterprise: IUserEnterprise | null;
}

/** `/auth/status` 带回的站内通知类型 */
export enum ENotificationType {
  /** 团队邀请 */
  Invitation = 'INVITATION'
}

/** 团队邀请通知。两个姓名都可能是 null */
export interface IInvitationNotification {
  type: ENotificationType.Invitation;
  payload: {
    /** 接受与拒绝都按它提交 */
    invitationBizId: string;
    /** 受邀人姓名，管理员在邀请时预设 */
    memberName: string | null;
    /** 邀请人姓名 */
    operatorName: string | null;
    /** 邀请方的企业名 */
    enterpriseName: string;
  };
}

/** 站内通知。目前只有团队邀请一种，新增类型时扩成联合 */
export type TNotification = IInvitationNotification;

/** `IUserSession.loginStatus` 的登录态取值，其余值一律视为未登录 */
export const LOGGED_IN_STATUS = 1;

/** 账号状态，仅在会话已失效时下发。字面值待与后端核对 */
export enum EAccountStatus {
  /** 账号被停用 */
  Deactivate = 'DEACTIVATE',
  /** 账号被删除 */
  Deleted = 'DELETED'
}

export interface IUserSession {
  loginStatus: number;
  sessionId: string;
  /** 会话已失效时为 null */
  userId: string | null;
  /** 待处理的站内通知，已处理完的不再带回来 */
  notifications?: TNotification[];
  /**
   * 会话失效的账号侧原因，仅在失效时下发。
   * 刻意不标成 `EAccountStatus`：它是外部数据，收窄由 `authSync` 的映射 switch 完成
   */
  accountStatus?: string;
  /**
   * 抢救保存凭证，120s 内可反复使用。只有带着已回收 cookie 的那一趟才下发，
   * 而该响应自带 Set-Cookie，所以整个浏览器只有第一个发出本请求的标签页拿得到
   */
  salvageToken?: string;
}
